import { Outlet } from 'react-router-dom'
import { Navbar } from './Navbar/Navbar'
import { Footer } from './Footer/Footer'
import { AppBanner } from '../components/AppBanner/AppBanner'

export function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col relative z-10 overflow-x-clip" style={{ paddingTop: 'var(--banner-h, 0px)', transition: 'padding-top .35s' }}>
      <AppBanner />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
